import React from "react";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import { connect } from "react-redux";
import Container from "react-bootstrap/Container";
import Dropdown from "react-bootstrap/Dropdown";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import DropdownButton from "react-bootstrap/DropdownButton";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import "./PdfEditArticleImageList.css";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import { setPdfImageBoxesAction } from "../../redux/actions/singlePdfPageContainer";
import { getPageImagesApi, getPagePageImageApi } from "../../api/pages";
import UploadPageImageModal from "../UploadPageImageModal/UploadPageImageModal";
import RotateModal from "../RotateModal/RotateModal";
import ScreenshotModal from "../ScreenshotModal/ScreenshotModal";
import CombineImageModal from "../CombineImageModal/CombineImageModal";
import { sendImageRequestAction } from "../../redux/actions/editArticlePanel";
import "react-image-crop/dist/ReactCrop.css";
import { getPageDataApi } from "../../api/pages";

class PdfEditArticleImageList extends React.Component {
  constructor(props) {
    super(props);
    this.loadPages = this.loadPages.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.imageClicked = this.imageClicked.bind(this);
    this.imageRotateClicked = this.imageRotateClicked.bind(this);
    this.imageMergeClicked = this.imageMergeClicked.bind(this);
    this.handleCombineSwitch = this.handleCombineSwitch.bind(this);
    this.pageClicked = this.pageClicked.bind(this);
    this.getCurrentPageIDs = this.getCurrentPageIDs.bind(this);
    this.pagingBtnRefs = {};
    this.scrollPageBtns = this.scrollPageBtns.bind(this);
    this.handleReload = this.handleReload.bind(this);
    this.reloadPageImage = this.reloadPageImage.bind(this);
    this.state = {
      imgs: null,
      showAddImage: false,
      showScreenshot: false,
      showRotateImageID: null,
      showMergeLeftImageID: null,
      showMergeRightImageID: null,

      loadedLeftPage: null,
      loadedRightPage: null
    };
  }

  scrollPageBtns() {
    const { leftPage, rightPage } = this.props;

    if (
      leftPage != null &&
      leftPage >= 0 &&
      this.pagingBtnRefs[leftPage + 1] != null
    ) {
      this.pagingBtnRefs[leftPage + 1].scrollIntoView({ behavior: "auto" });
    }

    if (
      rightPage != null &&
      rightPage >= 0 &&
      this.pagingBtnRefs[rightPage + 1] != null
    ) {
      this.pagingBtnRefs[rightPage + 1].scrollIntoView({ behavior: "auto" });
    }
  }

  pageClicked(page) {
    this.props.pageClicked(page);
  }

  handleReload() {
    this.loadPages();
    this.reloadPageImage();
  }

  handleCloseModal(reload) {
    if (reload) {
      this.loadPages();
    }

    this.setState({
      showAddImage: false,
      showScreenshot: false,
      showRotateImageID: null,
      showMergeLeftImageID: null,
      showMergeRightImageID: null
    });
  }

  imageRotateClicked(imageID) {
    this.setState({
      showRotateImageID: imageID
    });
  }

  handleCombineSwitch() {
    const { showMergeLeftImageID, showMergeRightImageID } = this.state;

    this.setState({
      showMergeLeftImageID: showMergeRightImageID,
      showMergeRightImageID: showMergeLeftImageID
    });
  }

  getCurrentPageIDs() {
    const { article, leftPage, rightPage } = this.props;
    const { pages } = article;

    let pageNumToProcess = [];

    if (
      leftPage <= article.last_page - 1 &&
      leftPage >= article.first_page - 1
    ) {
      pageNumToProcess.push(leftPage - article.first_page + 1);
    }

    if (
      rightPage <= article.last_page - 1 &&
      rightPage >= article.first_page - 1
    ) {
      pageNumToProcess.push(rightPage - article.first_page + 1);
    }

    if (pageNumToProcess.length <= 0) {
      return [];
    }

    pageNumToProcess.sort();

    let idArr = pageNumToProcess.map(aPageNum => {
      const pageID = pages[aPageNum].id;
      return pageID;
    });

    return idArr;
  }

  imageMergeClicked(imageID) {
    const { showMergeLeftImageID, showMergeRightImageID } = this.state;

    if (imageID === showMergeLeftImageID) {
      this.setState({ showMergeLeftImageID: null });
      return;
    }

    if (imageID === showMergeRightImageID) {
      this.setState({ showMergeRightImageID: null });
      return;
    }

    if (showMergeLeftImageID == null && showMergeRightImageID == null) {
      this.setState({ showMergeLeftImageID: imageID });
    } else if (showMergeLeftImageID != null && showMergeRightImageID == null) {
      this.setState({ showMergeRightImageID: imageID });
    } else if (showMergeLeftImageID != null && showMergeRightImageID != null) {
      this.setState({
        showMergeLeftImageID: showMergeRightImageID,
        showMergeRightImageID: imageID
      });
    } else {
      this.setState({ showMergeRightImageID: imageID });
    }
  }

  imageClicked(image) {
    const { issue } = this.props;
    const issueID = issue.id;

    this.props.sendImageRequestAction(image, issueID, toast);
  }

  componentDidMount() {
    this.loadPages();
    this.scrollPageBtns();
  }

  componentDidUpdate(prevProps) {
    const { article, leftPage, rightPage, pageArr, activeKey } = this.props;

    if (
      prevProps.article == null ||
      article.id !== prevProps.article.id ||
      prevProps.leftPage !== leftPage ||
      prevProps.rightPage !== rightPage
    ) {
      this.loadPages();
    }

    if (
      prevProps.leftPage !== leftPage ||
      prevProps.rightPage !== rightPage ||
      prevProps.pageArr !== pageArr ||
      prevProps.activeKey !== activeKey
    ) {
      this.scrollPageBtns();
    }
  }

  async loadPages() {
    this.setState({ imgs: null });

    const { article, leftPage, rightPage } = this.props;
    const { pages } = article;

    let pageNumToProcess = [];

    if (
      leftPage <= article.last_page - 1 &&
      leftPage >= article.first_page - 1
    ) {
      pageNumToProcess.push(leftPage - article.first_page + 1);
    }

    if (
      rightPage <= article.last_page - 1 &&
      rightPage >= article.first_page - 1
    ) {
      pageNumToProcess.push(rightPage - article.first_page + 1);
    }

    if (pageNumToProcess.length <= 0) {
      this.setState({
        imgs: [],
        loadedRightPage: rightPage,
        loadedLeftPage: leftPage
      });
      return;
    }

    pageNumToProcess.sort();

    let promiseArr = pageNumToProcess.map(aPageNum => {
      const pageID = pages[aPageNum].id;
      return getPageImagesApi(pageID);
    });

    let fullPagePromiseArr = pageNumToProcess.map(aPageNum => {
      const pageID = pages[aPageNum].id;
      return getPagePageImageApi(pageID);
    });

    let returnArr = [];
    let idArr = [];

    try {
      const result = await Promise.all(promiseArr).catch(e => {
        throw e;
      });
      const fullPgaeResult = await Promise.all(fullPagePromiseArr).catch(e => {
        throw e;
      });

      for (let i = 0; i < result.length; i++) {
        for (let j = 0; j < result[i].length; j++) {
          if (idArr.indexOf(result[i][j].id) < 0) {
            const item = result[i][j];
            item.imageUri = `${process.env.REACT_APP_API_ROOT}artworks/${
              item.id
            }/static/thumbnail`;

            idArr.push(item.id);
            returnArr.push(item);
          }
        }
      }

      for (let i = 0; i < fullPgaeResult.length; i++) {
        if (idArr.indexOf(fullPgaeResult[i].id) < 0) {
          const item = fullPgaeResult[i];
          item.imageUri = `${process.env.REACT_APP_API_ROOT}artworks/${
            item.id
          }/static/thumbnail`;

          idArr.push(item.id);
          returnArr.push(item);
        }
      }

      returnArr.sort((a, b) => b.created_at - a.created_at);

      this.setState({
        imgs: returnArr,
        loadedRightPage: rightPage,
        loadedLeftPage: leftPage
      });
    } catch (e) {
      toast.error(e.toString());
    }
  }

  async reloadPageImage() {
    const { issue, leftPage, rightPage, setPdfImageBoxesAction } = this.props;

    if (issue == null) {
      return;
    }

    try {
      if (leftPage >= 0) {
        const leftPageData = await getPageDataApi(issue.pages[leftPage].id);
        if (this.props.issue === issue && this.props.leftPage === leftPage) {
          setPdfImageBoxesAction({
            isLeft: true,
            imageBoxes: leftPageData.placeable_images
          });
        }
      }
    } catch (e) {
      setPdfImageBoxesAction({ isLeft: true, imageBoxes: [] });
      toast.error(e.toString());
    }

    try {
      if (rightPage >= 0) {
        const rightPageData = await getPageDataApi(issue.pages[rightPage].id);
        if (this.props.issue === issue && this.props.rightPage === rightPage) {
          setPdfImageBoxesAction({
            isLeft: false,
            imageBoxes: rightPageData.placeable_images
          });
        }
      }
    } catch (e) {
      setPdfImageBoxesAction({ isLeft: false, imageBoxes: [] });
      toast.error(e.toString());
    }
  }

  render() {
    const { imgs, loadedLeftPage, loadedRightPage } = this.state;

    const { article, issue, leftPage, rightPage, pageArr } = this.props;

    let pageID = null;
    let pageIDarr = this.getCurrentPageIDs();
    if (pageIDarr.length > 0) {
      pageID = pageIDarr[0];
    }

    const isLoading =
      imgs == null ||
      loadedLeftPage !== leftPage ||
      loadedRightPage !== rightPage;

    const { showMergeLeftImageID, showMergeRightImageID } = this.state;

    let chunkArray = [];

    if (!isLoading) {
      for (let i = 0; i < imgs.length; i += 3) {
        let aChunk = imgs.slice(i, i + 3);
        chunkArray.push(aChunk);
      }
    }

    return (
      <Container className="pdf_thumb_image_container">
        <Row>
          <Col>
            <DropdownButton
              disabled={isLoading}
              className="article_add_image_btn"
              variant="warning"
              title="Add"
              style={{ display: "inline" }}
            >
              <Dropdown.Item
                onClick={() => this.setState({ showAddImage: true })}
              >
                Upload/URL
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => this.setState({ showScreenshot: true })}
              >
                Screenshot
              </Dropdown.Item>
            </DropdownButton>

            <ButtonGroup className="article_paging_btns" variant="info">
              <Button
                variant="info"
                className="toc_paging_btn"
                onClick={this.props.leftDoubleClicked}
              >
                <span className="fa fa-angle-double-left" />
              </Button>
              <Button
                variant="info"
                className="toc_paging_btn"
                onClick={this.props.leftClicked}
              >
                <span className="fa fa-angle-left" />
              </Button>
              <Button
                variant="info"
                className="toc_paging_btn"
                onClick={this.props.rightClicked}
              >
                <span className="fa fa-angle-right" />
              </Button>
              <Button
                variant="info"
                className="toc_paging_btn"
                onClick={this.props.rightDoubleClicked}
              >
                <span className="fa fa-angle-double-right" />
              </Button>
            </ButtonGroup>
          </Col>
          <Col xs="12" sm="12" md="12" lg="6" xl="8">
            <ButtonGroup
              className="article_paging_btns article_page_num_btns"
              variant="info"
            >
              {pageArr.map(page => (
                <Button
                  key={page}
                  ref={ref => (this.pagingBtnRefs[page] = ref)}
                  variant={
                    page - 1 === leftPage || page - 1 === rightPage
                      ? "dark"
                      : "secondary"
                  }
                  className="toc_paging_btn"
                  onClick={() => this.pageClicked(page)}
                >
                  {page}
                </Button>
              ))}
            </ButtonGroup>
          </Col>
        </Row>

        {isLoading && (
          <div className="article_spinner_container">
            <Spinner animation="grow" />
          </div>
        )}

        {!isLoading &&
          chunkArray.map((aChunk, idx) => {
            return (
              <Row className="pdf_thumb_image" key={idx}>
                {aChunk.map(anImage => {
                  const imageUri = anImage.imageUri;
                  return (
                    <Col key={anImage.id} xs="4" sm="4" md="4" lg="3" xl="2">
                      <div className="image_thumb_container">
                        <Image
                          src={imageUri}
                          thumbnail
                          onClick={() => this.imageClicked(anImage)}
                        />
                        <Button
                          className="select_rotate_btn"
                          variant="primary"
                          size="sm"
                          onClick={() => this.imageRotateClicked(anImage.id)}
                        >
                          <span className="fa fa-undo" />
                        </Button>
                        <Button
                          className="select_merge_btn"
                          variant={
                            anImage.id === showMergeLeftImageID ||
                            anImage.id === showMergeRightImageID
                              ? "warning"
                              : "info"
                          }
                          size="sm"
                          onClick={() => this.imageMergeClicked(anImage.id)}
                        >
                          <span className="fa fa-qrcode" />
                        </Button>
                      </div>
                      <div className="image_thumb_size">
                        {anImage.width} x {anImage.height}
                      </div>
                    </Col>
                  );
                })}
              </Row>
            );
          })}

        {pageID && this.state.showAddImage && (
          <UploadPageImageModal
            pageID={pageID}
            showCreateModal={this.state.showAddImage}
            handleCloseModal={this.handleCloseModal}
          />
        )}
        {pageID && this.state.showScreenshot && (
          <ScreenshotModal
            issue={issue}
            article={article}
            pageID={pageID}
            leftPage={leftPage}
            rightPage={rightPage}
            pageArr={this.props.pageArr}
            showCreateModal={this.state.showScreenshot}
            handleCloseModal={this.handleCloseModal}
            handleReload={this.handleReload}
          />
        )}
        {pageID && this.state.showRotateImageID && (
          <RotateModal
            pageID={pageID}
            imageID={this.state.showRotateImageID}
            showCreateModal={this.state.showRotateImageID != null}
            handleCloseModal={this.handleCloseModal}
          />
        )}
        {pageID &&
          this.state.showMergeLeftImageID != null &&
          this.state.showMergeRightImageID != null && (
            <CombineImageModal
              pageID={pageID}
              leftImageID={this.state.showMergeLeftImageID}
              rightImageID={this.state.showMergeRightImageID}
              showCreateModal={
                this.state.showMergeLeftImageID != null &&
                this.state.showMergeRightImageID != null
              }
              handleCloseModal={this.handleCloseModal}
              handleCombineSwitch={this.handleCombineSwitch}
            />
          )}
      </Container>
    );
  }
}

const mapDispatch = {
  sendImageRequestAction,
  setPdfImageBoxesAction
};

export default connect(
  null,
  mapDispatch
)(PdfEditArticleImageList);
